export default {
	HEADER: 'Header',
	MY_LIBRARY: 'My Library',
	ONBOARDING_GUIDE: 'Onboarding Guide',
	THUMBNAIL: 'Thumbnail',
}
